import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
import '~/styles/estilo.css';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Textarea from '~/components/Form/Textarea';

import { Container } from './styles';

export default function Email({ location, match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [emailLead, setEmailLead] = useState('');
  const [atendimento, setAtendimento] = useState(0);
  const [carregar, setCarregar] = useState(false);

  useEffect(() => {
    async function getDados() {
      const { id } = match.params;

      const response = await api.get(`email-atendimento/${id}`)

      const data = response.data

      data.corpo = data.corpo.replace('[CLIENTE]', location.state.name)

      setDado(data);
      setEmailLead(location.state.email);
      setAtendimento(id);
    }
    getDados();
  }, [
    location,
    location.state.dados,
    location.state.email,
    match.params,
    setAtendimento,
  ]);

  async function handlerEnviar(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        assunto: Yup.string().required('Preencha o campo assunto'),
        corpo: Yup.string().required('Preencha o campo corpo'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/atendimento/${atendimento}/disparar-email`, {
        email: emailLead,
        corpo: data.corpo,
        assunto: data.assunto,
      });

      toast.success('E-mail enviado com sucesso');
      history.push(`/atendimento-create/${atendimento}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao enviar e-mail, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Disparo de e-mail</h4>
      <Card>
        <Form ref={inputRef} initialData={dado} onSubmit={handlerEnviar}>
          <Input icon="MdMail" label="Assunto" name="assunto" type="text" />
          <Textarea name="corpo" label="Corpo" />
          <Button tamanho="40px" load={carregar}>
            Enviar E-mail
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

Email.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      dados: PropTypes.string,
      email: PropTypes.string,
      assunto: PropTypes.string,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
